export default __webpack_public_path__ + "static/media/Gate.8b853de0.svg";